/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0
 */
var $spacing_0 = 0;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 4px
 */
var $spacing_s1 = 4;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 8px
 */
var $spacing_s2 = 8;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 12px
 */
var $spacing_s3 = 12;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 16px
 */
var $spacing_s4 = 16;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 20px
 */
var $spacing_m1 = 20;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 24px
 */
var $spacing_m2 = 24;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 32px
 */
var $spacing_m3 = 32;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 40px
 */
var $spacing_l1 = 40;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 48px
 */
var $spacing_l2 = 48;

/**
 *
 * @description enDesc: -
 * @description type: global
 * @description  globalToken: -
 * @description  value: 56px
 */
var $spacing_l3 = 56;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-0
 * @description  value: 0
 */
var $margin_none = $spacing_0;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s1
 * @description  value: 4px
 */
var $margin_xxs = $spacing_s1;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s2
 * @description  value: 8px
 */
var $margin_xs = $spacing_s2;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s3
 * @description  value: 12px
 */
var $margin_sm = $spacing_s3;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s4
 * @description  value: 16px
 */
var $margin_base = $spacing_s4;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-m1
 * @description  value: 20px
 */
var $margin_lg = $spacing_m1;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-m2
 * @description  value: 24px
 */
var $margin_xlg = $spacing_m2;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-m3
 * @description  value: 32px
 */
var $margin_xxlg = $spacing_m3;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-0
 * @description  value: 0
 */
var $padding_none = $spacing_0;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s1
 * @description  value: 4px
 */
var $padding_xxs = $spacing_s1;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s2
 * @description  value: 8px
 */
var $padding_xs = $spacing_s2;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s3
 * @description  value: 12px
 */
var $padding_sm = $spacing_s3;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-s4
 * @description  value: 16px
 */
var $padding_base = $spacing_s4;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-m1
 * @description  value: 20px
 */
var $padding_lg = $spacing_m1;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-m2
 * @description  value: 24px
 */
var $padding_xlg = $spacing_m2;

/**
 *
 * @description enDesc: -
 * @description type: alias
 * @description  globalToken: $spacing-m3
 * @description  value: 32px
 */
var $padding_xxlg = $spacing_m3;
var $control_height = $spacing_m3;
var $control_height_sm = $spacing_m2;
var $control_height_lg = $spacing_l1;

export { $control_height, $control_height_lg, $control_height_sm, $margin_base, $margin_lg, $margin_none, $margin_sm, $margin_xlg, $margin_xs, $margin_xxlg, $margin_xxs, $padding_base, $padding_lg, $padding_none, $padding_sm, $padding_xlg, $padding_xs, $padding_xxlg, $padding_xxs, $spacing_0, $spacing_l1, $spacing_l2, $spacing_l3, $spacing_m1, $spacing_m2, $spacing_m3, $spacing_s1, $spacing_s2, $spacing_s3, $spacing_s4 };
